var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"scroll-board"},[_c('dv-scroll-board',{attrs:{"config":_vm.config}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }